var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinkButton } from '@hn-ui/buttons';
import { styled } from 'styled-components';
var CalendarNotice = styled.p.withConfig({ displayName: "CalendarNotice", componentId: "sc-aslod3" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  margin: 0;\n"], ["\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  margin: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var ButtonLink = styled(LinkButton).withConfig({ displayName: "ButtonLink", componentId: "sc-1tohi0z" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline;\n"], ["\n  display: inline;\n"])));
var PastWeekNotice = function (_a) {
    var weekRange = _a.weekRange, onBackClick = _a.onBackClick, rest = __rest(_a, ["weekRange", "onBackClick"]);
    return (_jsxs(CalendarNotice, __assign({}, rest, { children: ["You\u2019re looking at a week in the past", weekRange ? " (" + weekRange + ")" : '', ".", ' ', _jsx(ButtonLink, __assign({ fit: true, onClick: onBackClick }, { children: "Back to current week" }), void 0)] }), void 0));
};
export { PastWeekNotice };
var templateObject_1, templateObject_2;
